import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const FALLBACK = [
  { name: "Daniel K.", role: "Dad of three, pancake specialist", quote: "One sheet handled an entire glass of spilled orange juice. We buy the 15-pack now, no questions.", img: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=200&q=80" },
  { name: "Priya S.", role: "Home chef", quote: "Strong enough to scrub my cast iron while wet. Soft enough to pat herbs dry.", img: "https://images.pexels.com/photos/3868929/pexels-photo-3868929.jpeg?auto=compress&cs=tinysrgb&w=200" },
];

const cardVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Testimonials = () => {
  const { content } = useContent();
  const reviews = content?.testimonials?.length ? content.testimonials : FALLBACK;
  return (
    <section id="reviews" className="relative bg-sky-50/90 py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] font-bold text-sky-600 mb-4">Customer-tested</p>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 mb-16 max-w-2xl">
          Loved by messy mornings <span className="text-amber-500">everywhere.</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {reviews.map((r, i) => (
            <motion.div
              key={r.name + i}
              custom={i}
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="relative bg-white rounded-[2rem] p-7 shadow-lg shadow-sky-900/5 border border-sky-100 hover:-translate-y-2 transition-transform duration-300"
              data-testid={`testimonial-card-${i + 1}`}
            >
              <Quote size={28} className="text-sky-200 mb-3" />
              <div className="flex gap-1 text-amber-400 mb-3">
                {[...Array(5)].map((_, s) => (<Star key={s} size={14} fill="currentColor" />))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6 text-sm">&ldquo;{r.quote}&rdquo;</p>
              <div className="flex items-center gap-3">
                {r.img ? (
                  <img src={r.img} alt={r.name} className="w-11 h-11 rounded-full object-cover" />
                ) : (
                  <span className="w-11 h-11 rounded-full bg-amber-400 text-slate-900 font-display font-extrabold flex items-center justify-center">
                    {(r.name || "?")[0]}
                  </span>
                )}
                <div>
                  <p className="font-display font-bold text-slate-900 text-sm">{r.name}</p>
                  <p className="text-xs text-slate-500">{r.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
